import ChooseCountry from "@/modules/document/pages/ChooseCountry.vue";
import ChooseDocument from "@/modules/document/pages/ChooseDocument.vue";
import License from "@/modules/license/routes/index";
import Passport from "@/modules/passport/routes/index";
import National from "@/modules/national/routes/index";
export default [
  {
    path: "/document/choose-country",
    name: "chooseCountry",
    component: ChooseCountry,
  },
  {
    path: "/document/choose-document",
    name: "chooseDocument",
    component: ChooseDocument,
  },
  ...License,
  ...Passport,
  ...National,
];
